export const FEATURE_NAME = '@zerops/zerops/feature/addon-activation-dialog';
